


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { RequestStatus } from '../utils/constans';
import { formatBackTime } from '../utils/common';
import { iAlumnus } from '../typings/students';
import $api from '../api';

@Component
export default class StudnetsView extends Vue {

  private alumnsList: iAlumnus[] = [];

  private mounted() {
    this.getAlumnusList();
  }

  private getAlumnusList() {
     $api.students.findAllAlumnusClient()
    .then((res) => {
      const alumnsList: iAlumnus[] = [];
      (res as any).map( (record: iAlumnus) => {
        // to do
        alumnsList.push(record);
      });
      this.alumnsList = alumnsList;
    });
  }
}
